module.exports = __webpack_public_path__ + "img/2_h_uk.9656e860.svg";